import { ProductRestV2Repository, ProductService } from './core';

export * from './core';
export * from './utils';

const productRepository = new ProductRestV2Repository();
const productService = new ProductService(productRepository);

export { productService };
